<template>
  <div class="dashboard-page">
    <!-- KPI 指标卡片区 -->
    <div class="kpi-section">
      <div class="kpi-card" v-for="(item, index) in kpiData" :key="index">
        <div class="kpi-main">
          <div class="kpi-icon" v-html="item.icon"></div>
          <div class="kpi-info">
            <div class="kpi-value">{{ item.value }}</div>
            <div class="kpi-label">{{ item.label }}</div>
            <div class="kpi-trend" :class="item.trend > 0 ? 'up' : 'down'">
              <span>{{ item.trend > 0 ? '▲' : '▼' }}</span>
              <span>{{ Math.abs(item.trend) }}%</span>
              <span class="trend-text">环比上月</span>
            </div>
          </div>
        </div>
        <div class="kpi-chart-mini" :ref="'miniChart' + index"></div>
      </div>
    </div>

    <!-- 中间图表区 -->
    <div class="charts-row">
      <div class="chart-panel panel-large">
        <div class="panel-header">
          <span class="panel-title">📈 月度销售趋势</span>
          <span class="panel-sub">近12个月成交金额走势</span>
        </div>
        <div class="panel-body">
          <div ref="trendChart" class="echarts-container"></div>
        </div>
      </div>

      <div class="chart-panel panel-small">
        <div class="panel-header">
          <span class="panel-title">🎯 客户来源分布</span>
          <span class="panel-sub">各渠道获客占比</span>
        </div>
        <div class="panel-body">
          <div ref="sourceChart" class="echarts-container"></div>
        </div>
      </div>
    </div>

    <!-- 底部图表区 -->
    <div class="charts-row">
      <div class="chart-panel panel-medium">
        <div class="panel-header">
          <span class="panel-title">🔻 销售转化漏斗</span>
          <span class="panel-sub">从线索到成交全流程</span>
        </div>
        <div class="panel-body">
          <div ref="funnelChart" class="echarts-container"></div>
        </div>
      </div>

      <div class="chart-panel panel-medium">
        <div class="panel-header">
          <span class="panel-title">🏆 销售团队业绩排行</span>
          <span class="panel-sub">本月成交金额 TOP8</span>
        </div>
        <div class="panel-body">
          <div ref="rankChart" class="echarts-container"></div>
        </div>
      </div>
    </div>

    <!-- 底部信息条 -->
    <div class="bottom-info">
      <div class="info-item">
        <span class="info-dot" style="background: #4CAF50;"></span>
        <span>系统运行正常</span>
      </div>
      <div class="info-item">
        <span>数据更新时间：{{ updateTime }}</span>
      </div>
      <div class="info-item">
        <span>当前在线：{{ onlineUsers }} 人</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CrmDashboard',
  data() {
    return {
      updateTime: '',
      onlineUsers: 42,
      kpiData: [
        {
          icon: '<svg viewBox="0 0 24 24" fill="none" stroke="#4CAF50" stroke-width="2"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></svg>',
          value: '12,847',
          label: '总客户数',
          trend: 8.5,
          sparkline: [120, 132, 101, 134, 90, 230, 210, 180, 250, 280, 320, 350]
        },
        {
          icon: '<svg viewBox="0 0 24 24" fill="none" stroke="#81C784" stroke-width="2"><path d="M12 1v22M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/></svg>',
          value: '¥486.5万',
          label: '本月营收',
          trend: 12.3,
          sparkline: [220, 182, 191, 234, 290, 330, 310, 350, 380, 420, 450, 486]
        },
        {
          icon: '<svg viewBox="0 0 24 24" fill="none" stroke="#66BB6A" stroke-width="2"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>',
          value: '36',
          label: '今日成交',
          trend: -2.1,
          sparkline: [5, 8, 12, 7, 9, 15, 18, 12, 20, 25, 30, 36]
        },
        {
          icon: '<svg viewBox="0 0 24 24" fill="none" stroke="#A5D6A7" stroke-width="2"><path d="M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="8.5" cy="7" r="4"/><line x1="20" y1="8" x2="20" y2="14"/><line x1="23" y1="11" x2="17" y2="11"/></svg>',
          value: '1,256',
          label: '新增线索',
          trend: 15.8,
          sparkline: [80, 92, 101, 134, 90, 130, 110, 150, 180, 200, 230, 256]
        }
      ],
      charts: {}
    }
  },
  mounted() {
    this.updateTime = new Date().toLocaleString('zh-CN')
    this.$nextTick(() => {
      this.initMiniCharts()
      this.initTrendChart()
      this.initSourceChart()
      this.initFunnelChart()
      this.initRankChart()
    })
    window.addEventListener('resize', this.handleResize)
    this.refreshTimer = setInterval(() => {
      this.updateTime = new Date().toLocaleString('zh-CN')
      this.onlineUsers = Math.floor(Math.random() * 20) + 35
    }, 30000)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    clearInterval(this.refreshTimer)
    Object.values(this.charts).forEach(chart => chart && chart.dispose())
  },
  methods: {
    getChartTheme() {
      return {
        textColor: '#a5d6a7',
        axisColor: 'rgba(76, 175, 80, 0.2)',
        splitLine: 'rgba(76, 175, 80, 0.08)'
      }
    },

    initMiniCharts() {
      this.kpiData.forEach((item, index) => {
        const dom = this.$refs['miniChart' + index]
        if (!dom || !dom[0]) return
        const chart = this.$echarts.init(dom[0])
        const color = item.trend > 0 ? '#4CAF50' : '#EF5350'
        
        chart.setOption({
          grid: { top: 5, right: 5, bottom: 5, left: 5 },
          xAxis: { type: 'category', show: false, data: Array.from({length: 12}, (_, i) => i) },
          yAxis: { type: 'value', show: false },
          series: [{
            type: 'line',
            data: item.sparkline,
            smooth: true,
            symbol: 'none',
            lineStyle: { width: 2, color: color },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: item.trend > 0 ? 'rgba(76, 175, 80, 0.3)' : 'rgba(239, 83, 80, 0.3)' },
                { offset: 1, color: 'transparent' }
              ])
            }
          }]
        })
        this.charts['mini' + index] = chart
      })
    },

    initTrendChart() {
      const chart = this.$echarts.init(this.$refs.trendChart)
      const theme = this.getChartTheme()
      const months = ['7月', '8月', '9月', '10月', '11月', '12月', '1月', '2月', '3月', '4月', '5月', '6月']
      
      chart.setOption({
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(16, 42, 21, 0.95)',
          borderColor: 'rgba(76, 175, 80, 0.3)',
          textStyle: { color: '#e8f5e9' },
          axisPointer: { lineStyle: { color: 'rgba(76, 175, 80, 0.5)' } }
        },
        legend: {
          data: ['成交金额', '目标金额'],
          textStyle: { color: theme.textColor },
          top: 0,
          right: 10
        },
        grid: { left: 50, right: 20, top: 40, bottom: 25 },
        xAxis: {
          type: 'category',
          data: months,
          axisLine: { lineStyle: { color: theme.axisColor } },
          axisLabel: { color: theme.textColor, fontSize: 11 }
        },
        yAxis: {
          type: 'value',
          axisLine: { show: false },
          axisLabel: { color: theme.textColor, fontSize: 11, formatter: '{value}万' },
          splitLine: { lineStyle: { color: theme.splitLine } }
        },
        series: [
          {
            name: '成交金额',
            type: 'line',
            data: [320, 332, 301, 334, 390, 430, 410, 450, 480, 520, 560, 486],
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            lineStyle: { width: 3, color: '#4CAF50' },
            itemStyle: { color: '#4CAF50', borderWidth: 2, borderColor: '#0d1f0f' },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(76, 175, 80, 0.4)' },
                { offset: 1, color: 'rgba(76, 175, 80, 0.02)' }
              ])
            }
          },
          {
            name: '目标金额',
            type: 'line',
            data: [350, 350, 380, 380, 400, 450, 450, 480, 500, 520, 550, 550],
            smooth: true,
            symbol: 'none',
            lineStyle: { width: 2, color: '#81C784', type: 'dashed' },
            itemStyle: { color: '#81C784' }
          }
        ]
      })
      this.charts.trend = chart
    },

    initSourceChart() {
      const chart = this.$echarts.init(this.$refs.sourceChart)
      const theme = this.getChartTheme()
      
      chart.setOption({
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(16, 42, 21, 0.95)',
          borderColor: 'rgba(76, 175, 80, 0.3)',
          textStyle: { color: '#e8f5e9' },
          formatter: '{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          right: 10,
          top: 'center',
          textStyle: { color: theme.textColor, fontSize: 11 },
          itemWidth: 10,
          itemHeight: 10
        },
        series: [{
          type: 'pie',
          radius: ['45%', '70%'],
          center: ['35%', '50%'],
          avoidLabelOverlap: false,
          itemStyle: {
            borderRadius: 6,
            borderColor: '#0d1f0f',
            borderWidth: 2
          },
          label: {
            show: false,
            position: 'center'
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 16,
              fontWeight: 'bold',
              color: '#e8f5e9',
              formatter: '{b}\n{d}%'
            },
            itemStyle: {
              shadowBlur: 10,
              shadowColor: 'rgba(76, 175, 50, 0.5)'
            }
          },
          labelLine: { show: false },
          data: [
            { value: 4350, name: '自然搜索', itemStyle: { color: '#4CAF50' } },
            { value: 3100, name: '社交媒体', itemStyle: { color: '#66BB6A' } },
            { value: 2340, name: '付费广告', itemStyle: { color: '#81C784' } },
            { value: 1800, name: '客户转介', itemStyle: { color: '#A5D6A7' } },
            { value: 1257, name: '线下活动', itemStyle: { color: '#2E7D32' } }
          ]
        }]
      })
      this.charts.source = chart
    },

    initFunnelChart() {
      const chart = this.$echarts.init(this.$refs.funnelChart)
      // const theme = this.getChartTheme()
      
      chart.setOption({
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(16, 42, 21, 0.95)',
          borderColor: 'rgba(76, 175, 80, 0.3)',
          textStyle: { color: '#e8f5e9' },
          formatter: '{b}: {c}'
        },
        series: [{
          type: 'funnel',
          left: '10%',
          top: 20,
          bottom: 20,
          width: '80%',
          min: 0,
          max: 10000,
          minSize: '0%',
          maxSize: '100%',
          sort: 'descending',
          gap: 2,
          label: {
            show: true,
            position: 'inside',
            color: '#fff',
            fontSize: 12,
            formatter: '{b}\n{c}'
          },
          labelLine: { length: 10, lineStyle: { width: 1, type: 'solid' } },
          itemStyle: { borderColor: '#0d1f0f', borderWidth: 1 },
          emphasis: {
            label: { fontSize: 14 }
          },
          data: [
            { value: 10000, name: '线索录入', itemStyle: { color: '#1B5E20' } },
            { value: 7500, name: '初步接触', itemStyle: { color: '#2E7D32' } },
            { value: 5200, name: '需求确认', itemStyle: { color: '#388E3C' } },
            { value: 3500, name: '方案报价', itemStyle: { color: '#4CAF50' } },
            { value: 2100, name: '商务谈判', itemStyle: { color: '#66BB6A' } },
            { value: 1280, name: '成交签约', itemStyle: { color: '#81C784' } }
          ]
        }]
      })
      this.charts.funnel = chart
    },

    initRankChart() {
      const chart = this.$echarts.init(this.$refs.rankChart)
      const theme = this.getChartTheme()
      const salesData = [
        { name: '李明', value: 86.5 },
        { name: '王芳', value: 72.3 },
        { name: '张伟', value: 68.9 },
        { name: '刘洋', value: 61.2 },
        { name: '陈静', value: 55.8 },
        { name: '赵强', value: 48.6 },
        { name: '孙丽', value: 42.1 },
        { name: '周杰', value: 38.4 }
      ]
      
      chart.setOption({
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(16, 42, 21, 0.95)',
          borderColor: 'rgba(76, 175, 80, 0.3)',
          textStyle: { color: '#e8f5e9' },
          axisPointer: { type: 'shadow' },
          formatter: '{b}: {c}万'
        },
        grid: { left: 60, right: 30, top: 10, bottom: 10 },
        xAxis: {
          type: 'value',
          axisLine: { show: false },
          axisLabel: { color: theme.textColor, fontSize: 11, formatter: '{value}万' },
          splitLine: { lineStyle: { color: theme.splitLine } }
        },
        yAxis: {
          type: 'category',
          data: salesData.map(i => i.name).reverse(),
          axisLine: { lineStyle: { color: theme.axisColor } },
          axisLabel: { color: theme.textColor, fontSize: 12 },
          axisTick: { show: false }
        },
        series: [{
          type: 'bar',
          data: salesData.map(i => i.value).reverse(),
          barWidth: 14,
          itemStyle: {
            borderRadius: [0, 7, 7, 0],
            color: new this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [
              { offset: 0, color: '#1B5E20' },
              { offset: 0.5, color: '#2E7D32' },
              { offset: 1, color: '#4CAF50' }
            ])
          },
          label: {
            show: true,
            position: 'right',
            color: '#81C784',
            fontSize: 11,
            formatter: '{c}万'
          }
        }]
      })
      this.charts.rank = chart
    },

    handleResize() {
      Object.values(this.charts).forEach(chart => {
        chart && chart.resize()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard-page {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px;
  background: #0a1f0f;
  box-sizing: border-box;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(76, 175, 80, 0.2);
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: rgba(76, 175, 80, 0.4);
  }
}

// ===== KPI 卡片 =====
.kpi-section {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 16px;

  @media (max-width: 1400px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
}

.kpi-card {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 20px;
  background: linear-gradient(135deg, rgba(16, 42, 21, 0.9) 0%, rgba(13, 31, 15, 0.95) 100%);
  border: 1px solid rgba(76, 175, 80, 0.12);
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;

  &:hover {
    border-color: rgba(76, 175, 80, 0.3);
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3), 0 0 20px rgba(76, 175, 80, 0.05);
  }

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 20%;
    height: 60%;
    width: 3px;
    background: linear-gradient(180deg, #4CAF50, #2E7D32);
    border-radius: 0 2px 2px 0;
  }

  // 左侧主内容区：图标 + 文字信息
  .kpi-main {
    display: flex;
    align-items: flex-start;
    gap: 14px;
    flex: 1;
    min-width: 0; // 关键：允许flex子项收缩
  }

  .kpi-icon {
    width: 40px;
    height: 40px;
    flex-shrink: 0;
    background: rgba(76, 175, 80, 0.08);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid rgba(76, 175, 80, 0.15);
    padding: 5px;

    svg {
      width: 20px;
      height: 20px;
    }
  }

  .kpi-info {
    flex: 1;
    min-width: 0;

    .kpi-value {
      font-size: 22px;
      font-weight: 700;
      color: #e8f5e9;
      font-family: 'Courier New', monospace;
      letter-spacing: 1px;
      line-height: 1.2;
      white-space: nowrap;
    }

    .kpi-label {
      font-size: 13px;
      color: #66BB6A;
      margin-top: 4px;
      opacity: 0.8;
      white-space: nowrap;
    }

    .kpi-trend {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      margin-top: 8px;
      padding: 2px 8px;
      border-radius: 12px;
      font-size: 12px;
      font-weight: 500;
      white-space: nowrap;

      &.up {
        color: #4CAF50;
        background: rgba(76, 175, 80, 0.1);
      }

      &.down {
        color: #EF5350;
        background: rgba(239, 83, 80, 0.1);
      }

      .trend-text {
        font-size: 11px;
        opacity: 0.6;
        margin-left: 2px;
      }
    }
  }

  // 右侧迷你图
  .kpi-chart-mini {
    width: 80px;
    height: 50px;
    flex-shrink: 0;
  }
}

// ===== 图表面板通用 =====
.charts-row {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 16px;
  margin-bottom: 16px;

  &:last-of-type {
    margin-bottom: 12px;
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 1200px) {
    grid-template-columns: 1fr !important;
  }
}

.chart-panel {
  background: linear-gradient(135deg, rgba(16, 42, 21, 0.9) 0%, rgba(13, 31, 15, 0.95) 100%);
  border: 1px solid rgba(76, 175, 80, 0.12);
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;

  &:hover {
    border-color: rgba(76, 175, 80, 0.25);
  }

  .panel-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 18px;
    border-bottom: 1px solid rgba(76, 175, 80, 0.08);
    flex-shrink: 0;

    .panel-title {
      font-size: 15px;
      font-weight: 600;
      color: #e8f5e9;
      letter-spacing: 1px;
    }

    .panel-sub {
      font-size: 12px;
      color: #66BB6A;
      opacity: 0.7;
    }
  }

  .panel-body {
    flex: 1;
    padding: 10px;
    min-height: 280px;
    position: relative;
  }
}

.panel-large .panel-body { min-height: 320px; }
.panel-small .panel-body { min-height: 320px; }
.panel-medium .panel-body { min-height: 300px; }

.echarts-container {
  width: 100%;
  height: 100%;
  min-height: inherit;
}

// ===== 底部信息条 =====
.bottom-info {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  padding: 12px;
  background: rgba(16, 42, 21, 0.6);
  border: 1px solid rgba(76, 175, 80, 0.08);
  border-radius: 8px;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 8px;
  }

  .info-item {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: #66BB6A;
    opacity: 0.8;

    .info-dot {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      animation: pulse 2s infinite;
    }
  }
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
}

// ===== KPI 小屏幕响应式优化 =====
@media (max-width: 1400px) {
  .kpi-card {
    padding: 16px;

    .kpi-main {
      gap: 12px;
    }

    .kpi-icon {
      width: 36px;
      height: 36px;

      svg {
        width: 18px;
        height: 18px;
      }
    }

    .kpi-info {
      .kpi-value {
        font-size: 20px;
      }
    }

    .kpi-chart-mini {
      width: 70px;
      height: 44px;
    }
  }
}

@media (max-width: 768px) {
  .kpi-card {
    padding: 14px;

    .kpi-main {
      gap: 10px;
    }

    .kpi-icon {
      width: 32px;
      height: 32px;

      svg {
        width: 16px;
        height: 16px;
      }
    }

    .kpi-info {
      .kpi-value {
        font-size: 18px;
      }

      .kpi-label {
        font-size: 12px;
      }

      .kpi-trend {
        font-size: 11px;
        padding: 2px 6px;
      }
    }

    .kpi-chart-mini {
      width: 60px;
      height: 40px;
    }
  }
}
</style>